import { Module } from 'vuex';
import { NodeModelStoreModule, NodeModelStoreState } from '@/store/nodeModel';
import { LayerName } from '@etp/etp-pipelines-client/axios';
import { PipelinesStoreModule, PipelinesStoreState } from '@/store/pipelines';

const getDefaultState = () => {
  return {
    ...new NodeModelStoreModule('analytical').state,
    ...new PipelinesStoreModule(LayerName.AnalyticalLayer).state
  };
};

interface AnalyticalModelState
  extends NodeModelStoreState,
    PipelinesStoreState {}

const nodeModelStore = new NodeModelStoreModule('analytical');
const pipelinesStore = new PipelinesStoreModule(LayerName.AnalyticalLayer);

class AnalyticalModelModule implements Module<AnalyticalModelState, any> {
  namespaced = true;
  state = {
    ...nodeModelStore.state,
    ...pipelinesStore.state
  };
  getters = {
    ...nodeModelStore.getters,
    ...pipelinesStore.getters
  };
  actions = {
    ...nodeModelStore.actions,
    ...pipelinesStore.actions
  };
  mutations = {
    ...nodeModelStore.mutations,
    ...pipelinesStore.mutations,
    RESET_STATE(state: AnalyticalModelState) {
      Object.assign(state, getDefaultState());
    }
  };
}

export default new AnalyticalModelModule();
